import { React, useState } from "react";
import { useTranslation } from "react-i18next";
import ContestBox from "../Contest/ContestBox/ContestBox.jsx";
import JoinViaInviteCode from "../JoinViaInviteCode/JoinViaInviteCode";
import BaseHome from "../Home/BaseHome";
import RulesPopup from "../Popup/RulesPopup";
import WinningBreakup from "../Popup/WinningPopup";
import JoinViaInviteCodePopup from "../Popup/JoinViaInviteCodePopup";
import TournamentRoundPopup from "../Popup/SelectRoundPopup";
import JoiningPopup from "../Popup/JoiningPopup";
import Popup from "../Popup/BasePopup";
import { useEffect } from "react";
import { contestJoin } from "../../api/contest.api";
import TeamRegistration from "../Common/TeamRegistration";
import { toastError, toastSuccess } from '../../Utilities/toast.js'
import { useNavigate } from "react-router";
import NonPremiumMaxJoinPopup from "./NonPremiumMaxJoin.jsx";
import { t } from "i18next";

const ContestViaCode = ({ children, joinViaCodeContest, onJoinedContestDetails  }) => {
    const navigate = useNavigate();
    const [isRulesPopup, setIsRulesPopup] = useState(false);
    const [isPricePointPoolModel, setPricePointPool] = useState(false);
    const [isJoinViaInviteCode, setisJoinViaInviteCode] = useState(false);
    const [isTournamentRound, setisTournamentRound] = useState(false);
    const [isJoiningPopup, setJoiningPopup] = useState(false);
    const [selectedContest, setSelectedContest] = useState('');
    const [uniqueIgn, setUniqueIgn] = useState(null);
    const [isTeamRegistrationForm, setIsTeamRegistrationForm] = useState(false);
    const [isPopupOpenTournament, setPopupOpenTournament] = useState(true);
    const [isSubscriptionPopup, setSubscriptionPop] = useState(false);
    const [isDisableJoinBtn, setIsDisableJoinBtn] = useState(false);
    const [selectedMatchDate, setSelectedMatchDate] = useState('');

    const [userId, setuserId] = useState(null);
    const [gameName, setGameName] = useState('');
    const [paginationFilter, setPaginationFilter] = useState({
        pageNo: 1,
        recordPerPage: 10,
        sortBy: 'dateTime',
        sortDirection: 'asc'
    });

    const [rules, setRules] = useState([
        "KRAFTON will endeavor to eradicate misconducts described in the Rules of Conduct to ensure that the users can enjoy playing the game.",
    ]);

    useEffect(() => {
        setuserId(JSON?.parse(localStorage.getItem("profile"))?.user_id)
        let selectedGameName = localStorage.getItem('activeGame')
        setGameName(selectedGameName)
    }, [])

    const onJoinContestClick = (contest) => {
        setSelectedContest(contest);
        setIsDisableJoinBtn(false);
        setJoiningPopup(true);
    }
    const joiningContest = (contest) => {
        if (
            selectedContest?.gameTypeAry?.players &&
            parseInt(selectedContest?.gameTypeAry?.players) > 1
        ) {
            let data = {
                contest: selectedContest?._id,
                isActive: true,
                type: "contest",
                currencyCode: selectedContest?.currency?.[0]?.inCurrency?._id, //TODO: need to use get currency is function here avoid direct use incurrency 
                inGameUserName: uniqueIgn,
                uniqueIGN: uniqueIgn,
                user: userId
            };

            data.players = selectedContest?.gameTypeAry?.players
            data.extraPlayers = selectedContest?.gameTypeAry?.extraPlayers
            data.game_type = selectedContest?.gameTypeAry?._id
            data.game = selectedContest?.gameAry?._id
            localStorage.setItem("registerData", JSON.stringify(data))
            localStorage.setItem("registerType", "contest")

            setJoiningPopup(false);

            navigate("/team-registration")
        } else {
            console.log("CONTEST_JOIN", contest)
            setJoiningPopup(false);
            soloContestJoin();
        }
    }

    const soloContestJoin = async () => {
        try {
            let data = {
                contest: selectedContest?._id,
                inGameUserName: uniqueIgn,
                user: userId
            };
            const res = await contestJoin(data);
            if (res?.success && res?.data) {
                toastSuccess('Contest Join Successfully!');
                navigate(`/contest/details/${selectedContest?._id}`)
            }
            else {
                if(res?.data?.errors[0]?.code==="joinUserContests.messages.max_limit_exceed"){
                    setSubscriptionPop(true)
                }
                else if(res?.data?.errors[0]?.code==="events.validation.insufficient_balance") {
                  toastError(res?.data?.errors?.[0]?.msg);
                  setInterval(() => {
                    navigate(`/rewards`, { state: { status: 'coinStore' } })
                  }, 2000);
                }else{
                    setIsDisableJoinBtn(false);
                    toastError(res?.data?.errors?.[0]?.msg);
                }
            }
        } catch (error) {
            setIsDisableJoinBtn(false);
            console.log(error)
        }
    };


    return (
        <>
            {isPopupOpenTournament && (
                <Popup isOpen={isPopupOpenTournament} title={localStorage?.getItem('activeGame')?.toLocaleLowerCase() || "pubg"} onClose={() => setPopupOpenTournament(false)}>
                    <ContestBox contestData={joinViaCodeContest} onJoinContestClick={onJoinContestClick} onJoinedContestDetails={onJoinedContestDetails} />
                </Popup>
            )}

            {isRulesPopup && (
                <RulesPopup
                    isOpen={isRulesPopup}
                    title="Rules"
                    onClose={() => setIsRulesPopup(false)}
                    rules={rules}
                />
            )}
            {isPricePointPoolModel && (
                <WinningBreakup
                    isOpen={isPricePointPoolModel}
                    title="Winning Breakup"
                    onClose={() => setPricePointPool(false)}
                    popupType={'contest'}
                />
            )}

            {isTournamentRound && (
                <TournamentRoundPopup
                    setSelectedMatchDate={setSelectedMatchDate}
                    isOpen={isTournamentRound}
                    title="pmco"
                    onClose={() => setisTournamentRound(false)}
                />
            )}
            {isJoiningPopup && (
                <JoiningPopup  // contest Join popup
                    isOpen={isJoiningPopup}
                    title={selectedContest?.title}
                    popupType={'contest'}
                    contest={selectedContest}
                    setingameName={setUniqueIgn}
                    onJoinContest={joiningContest}
                    onClose={() => setJoiningPopup(false)}
                    isDisableJoinBtn={isDisableJoinBtn}
                    selectedMatchDate={selectedMatchDate}
                    setIsDisableJoinBtn={setIsDisableJoinBtn}
                />
            )}
            {isSubscriptionPopup && (
          <NonPremiumMaxJoinPopup
          isOpen={isSubscriptionPopup}
          message={t('premium.you_have_already_joined_today', { title: "contest", total:localStorage?.getItem('noOfContest') })}
          onClose={() => setSubscriptionPop(false)} title={"explore vi premium"}
          onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }}/>
        )}
        </>
    );
};

export default ContestViaCode;
